<div class="bg-surface overflow-hidden shadow sm:rounded-lg divide-y divide-separator">
  <div class="bg-surface p-4 border-b border-edge sm:px-6">
    <div class="flex justify-between flex-wrap sm:flex-nowrap">
      <div class="">
        <h3 class="text-lg leading-6 font-medium text-fg-primary">
          {{ cardTitle }}
        </h3>
      </div>
      <div class="flex-shrink-0 flex flex-col items-end gap-4">
        <div class="flex flex-row gap-2">
          @if (!disableSearch) {
            <div class="relative">
              <input appTailwindInput2 type="text" (input)="searchTextChanged($event)" />
              <div
                class="absolute inset-y-0 right-0 mr-2 flex items-center pointer-events-none text-fg-muted"
              >
                <app-ng-icon class="text-2xl" name="heroMagnifyingGlass"></app-ng-icon>
              </div>
            </div>
          }

          <button
            type="button"
            appTailwindButton
            color="white"
            size="xs"
            [disabled]="!(documents && documents.length > 0)"
            (click)="toggleMultiselect()"
          >
            @if (!isMultiselect) {
              <app-ng-icon class="text-2xl" name="heroPencil"></app-ng-icon>
            }
            @if (isMultiselect) {
              <app-ng-icon class="text-2xl" name="heroChevronUp"></app-ng-icon>
            }
          </button>
        </div>
        @if (!disableFilter) {
          <div class="flex flex-row gap-2 text-fg-muted">
            <div class="flex items-center h-5">
              <input
                id="revenue"
                (change)="typeFilterChange('revenue', $event)"
                [checked]="typeFilter?.includes('revenue')"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-fg-muted border-edge rounded disabled:bg-surface-disabled disabled:checked:bg-blue-400"
              />
              <div class="ml-2 text-xs">
                <label for="revenue" class="font-medium">Einnahmen</label>
              </div>
            </div>
            <div class="flex items-center h-5">
              <input
                id="expense"
                (change)="typeFilterChange('expense', $event)"
                [checked]="typeFilter?.includes('expense')"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-fg-muted border-edge rounded disabled:bg-surface-disabled disabled:checked:bg-blue-400"
              />
              <div class="ml-2 text-xs">
                <label for="expense" class="font-medium">Ausgaben</label>
              </div>
            </div>
            <div class="flex items-center h-5">
              <input
                id="other"
                (change)="typeFilterChange('other', $event)"
                [checked]="typeFilter?.includes('other')"
                type="checkbox"
                class="focus:ring-blue-500 h-4 w-4 text-fg-muted border-edge rounded disabled:bg-surface-disabled disabled:checked:bg-blue-400"
              />
              <div class="ml-2 text-xs">
                <label for="other" class="font-medium">Andere</label>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div>
    <app-document-list [documents]="documents" (editDocument)="editDocument.emit([$event])">
      @if (isMultiselect) {
        <div class="bg-blue-100 p-4 flex flex-row justify-between">
          <div class="flex flex-col md:flex-row gap-2">
            <button appTailwindButton color="white" size="xs" (click)="selectAll()">
              Alle auswählen
            </button>
            <button appTailwindButton size="xs" color="white" (click)="deselectAll()">
              Keines auswählen
            </button>
          </div>
          <div class="flex flex-col md:flex-row gap-2">
            <button
              [disabled]="!atLeastOneSelected"
              appTailwindButton
              color="white"
              size="xs"
              (click)="editSelectedDocuments()"
            >
              Bearbeiten
            </button>
            <button
              [disabled]="!atLeastOneSelected"
              appTailwindButton
              color="white"
              size="xs"
              (click)="downloadSelectedDocuments()"
            >
              Download
            </button>
            @if (updateAccountingProcessedEnabled) {
              <button
                appTailwindButton
                color="white"
                size="xs"
                [disabled]="!atLeastOneSelected"
                (click)="updateSelectedDocumentsAsProcessed()"
              >
                Verbucht
              </button>
            }
            @if (updateAccountingRelevantEnabled) {
              <button
                appTailwindButton
                color="white"
                size="xs"
                [disabled]="!atLeastOneSelected"
                (click)="updateSelectedDocumentsAsRelevant()"
              >
                Buchhaltungsrelevant
              </button>
            }
            <app-dropdown-minimal-menu>
              <app-dropdown-button>
                <button appTailwindButton color="white" size="xs" [disabled]="!atLeastOneSelected">
                  Verschieben
                </button>
              </app-dropdown-button>
              <app-dropdown-item (menuClick)="updateSelectedDocumentFolder(null)">
                Inbox
              </app-dropdown-item>
              @for (folder of folder$ | async; track folder) {
                <app-dropdown-item (menuClick)="updateSelectedDocumentFolder(folder)">
                  {{ folder.name }} ({{ folder.documentCount }})
                </app-dropdown-item>
              }
            </app-dropdown-minimal-menu>
          </div>
        </div>
      }
      @for (
        document of documentList | keyvalue: sortByDocumentDate;
        track document.key;
        let last = $last
      ) {
        <li
          app-document-list-item
          [id]="document.value.objectID"
          [name]="document.value.name ?? ''"
          [documentDate]="document.value.documentDate"
          [accounting]="document.value.accounting?.relevant ?? false"
          [accountingProcessed]="document.value.accounting?.processed ?? false"
          [archiveFolder]="document.value.folder"
          [linkedEntities]="document.value.linkedEntities ?? {}"
          [linkedUsers]="document.value.linkedUsers ?? {}"
          [internalInvoice]="
            document.value.type === 'revenue' ? (document.value.internalInvoice ?? false) : false
          "
          [documentAiState]="
            !document.value.curatedValuesReviewed ? (document.value.documentAiState ?? null) : null
          "
          [category]="document.value.type !== 'other' ? (document.value.category ?? null) : null"
          (editDocument)="editDocument.emit([document.value])"
          (deleteDocument)="deleteDocument.emit([document.value])"
          (downloadDocument)="downloadDocument(document.value)"
          (restartDocumentAi)="restartDocumentAi(document.value)"
          [selectable]="isMultiselect"
          [selected]="document.value.selected"
          (selectedChange)="selectionChanged($event, document.value)"
        ></li>
      }
    </app-document-list>
  </div>
  @if (enableShowAll) {
    <div class="w-full flex flex-col p-4 items-center">
      <div>
        <button appTailwindButton color="white" (click)="showAll.emit(true)">Alle anzeigen</button>
      </div>
    </div>
  }
</div>
